import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UILink from 'UIComponents/link/UILink';
import { AssignBusinessUnitOption } from 'automation-ui-canvas/components/flow-header/menu-bar/menuOptions/fileOptions';
import { AutomationPlatformFlowProperties } from 'automation-ui-management/constants/CrmWorkflowProperties';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { useQuery } from 'data-fetching-client';
import { CRM_OBJECT_SEARCH_FIELD_NAME, CRM_OBJECT_SEARCH_BY_FLOW_ID } from 'automation-ui-management/queries/crmObjectQueries';
import getIn from 'immutable-less/transmute/getIn';
import { ReviewMetadataColumn, StyledMetadataValue } from 'automation-ui-canvas/containers/review/StyledMetadataDetails';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import BusinessUnitName from 'automation-ui-references/customer-data/BusinessUnitName';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import { BusinessUnitsRebrandMessage } from 'ui-business-units-lib/components/BusinessUnitsRebrandMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BusinessUnitMetadata = ({
  flow,
  handleOpenPanelWithRedirect
}) => {
  const {
    loading,
    data: flowCrmObjectByIdData
  } = useQuery(CRM_OBJECT_SEARCH_BY_FLOW_ID, {
    variables: {
      flowId: String(flow.flowId)
    }
  });
  const crmObject = getIn([CRM_OBJECT_SEARCH_FIELD_NAME], flowCrmObjectByIdData);
  const buIds = crmObject && parseMultiEnumValue(getPropertyValue(crmObject, AutomationPlatformFlowProperties.BUSINESS_UNIT)).map(val => Number(val)) || [];
  return /*#__PURE__*/_jsxs(ReviewMetadataColumn, {
    children: [/*#__PURE__*/_jsx(UIFormLabel, {
      children: /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
        message: "platformReview.v2.detailsStep.businessUnit",
        rebrandMessage: "platformReview.v2.detailsStep.businessUnit_buv2"
      })
    }), loading ? /*#__PURE__*/_jsx(SkeletonText, {}) : buIds && buIds.length ? buIds.map(id => {
      return /*#__PURE__*/_jsx(StyledMetadataValue, {
        children: /*#__PURE__*/_jsx(BusinessUnitName, {
          businessUnitId: id
        })
      }, id);
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "platformReview.v2.detailsStep.none"
    }), /*#__PURE__*/_jsx(UILink, {
      onClick: () => {
        handleOpenPanelWithRedirect(AssignBusinessUnitOption.id);
      },
      children: /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
        message: "platformReview.v2.detailsStep.editBusinessUnit",
        rebrandMessage: "platformReview.v2.detailsStep.editBusinessUnit_buv2"
      })
    })]
  });
};
export default BusinessUnitMetadata;